module.exports = __webpack_public_path__ + "static/img/cont4.33a5d964.cdb047f0.png";